import { StyleSheet } from 'aphrodite';
import { aceGray, background, brandPrimary, charmGray, shuffleGray, titles, white } from '../../../web/styles/colors';

export const s = StyleSheet.create({
	root: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	content: {
		flex: 1,
		overflowY: 'auto',
		maxWidth: 768,
		margin: '0 auto',
		height: '100%',
		boxSizing: `border-box`,
		padding: `16px 0`,
		display: `flex`,
		flexDirection: `column`,
	},
	chat: {
		display: 'flex',
		gap: 16,
	},
	chatText: {
		display: 'flex',
		flexDirection: 'column',
		fontSize: '0.875rem',
		lineHeight: `30px`,
		':has(*) ul,ol': {
			paddingLeft: 16,
			margin: 0,
			listStyle: 'revert',
		},
		':has(*) li': {
			listStyle: 'inherit',
		},
	},
	assistantChatContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	assistantChatActions: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	assistantActionBtn: {
		width: 42,
		height: 42,
		backgroundColor: background,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 6,
		':focus-visible': {
			background: 'rgba(4, 102, 255, 0.05)',
		},
		':hover': {
			background: 'rgba(4, 102, 255, 0.05)',
		},
		':focus-visible:has(*) svg': {
			color: brandPrimary,
		},
		':hover:has(*) svg': {
			color: brandPrimary,
		},
	},
	lionAvatar: {
		width: 33,
		height: 37,
	},
	avatarWrapper: {
		width: 50,
		height: 50,
		backgroundColor: shuffleGray,
		borderRadius: '50%',
		border: '1px solid rgba(0, 102, 255, 0.68)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flex: 'none',
	},
	promptSection: {
		padding: 32,
		display: 'flex',
		justifyContent: 'center',
		gap: 8,
	},
	promptInputWrapper: {
		position: 'relative',
		maxHeight: 120,
		backgroundColor: white,
	},
	promptInput: {
		boxSizing: 'border-box',
		backgroundColor: 'transparent',
		borderRadius: 8,
		border: `1px solid ${shuffleGray}`,
		width: '100%',
		height: '100%',
		padding: `12px 16px 10px`,
		resize: 'none',
		fieldSizing: 'content',
		'::placeholder': {
			color: charmGray,
		},
		':placeholder-shown': {
			display: 'flex',
			alignItems: 'center',
		},
	},
	promptButton: {
		position: 'absolute',
		right: 8,
		top: '50%',
		transform: 'translateY(-50%)',
		width: 40,
		height: 40,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	myPrompt: {
		color: titles,
		padding: 16,
		fontSize: '1rem',
	},
	conversationInput: {
		background,
		width: '100%',
		maxWidth: 768,
	},
	saveContent: {
		fontSize: '1.125rem',
		color: brandPrimary,
		marginBottom: 16,
	},
	contentNameLabel: {
		fontSize: '0.75rem',
		color: charmGray,
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		marginBottom: 32,
	},
	saveContentInput: {
		background,
		borderRadius: 8,
		boxSizing: 'border-box',
		padding: `12px 16px`,
		border: 'none',
		color: titles,
		':focus': {
			outline: 'none',
		},
		':placeholder': {
			color: aceGray,
		},
	},
	actions: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	saveBtn: {
		width: 160,
	},
	saveDialogRoot: {
		padding: 16,
	},
	cancelBtn: {
		width: 32,
	},
	wireframeAction: {
		padding: `16px 32px`,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		gap: 8,
		backgroundColor: background,
		position: 'sticky',
		top: 0,
		zIndex: 1,
	},
	starterLayout: {
		backgroundColor: background,
	},
	newConversationButton: {
		boxSizing: `border-box`,
		display: `flex`,
		alignItems: `center`,
		justifyContent: `center`,
		padding: 12,
		color: charmGray,
		background,
		border: `1px solid ${shuffleGray}`,
		borderRadius: 8,
	},
});
